import {SVGProps} from 'react';

interface Props extends SVGProps<SVGSVGElement> {}

export const Close: React.FC<React.PropsWithChildren<Props>> = ({width = 20, height = 20, ...props}) => {
    const color = props.color || '#FFF';
    return (
        <svg
            width={width}
            height={height}
            fill="none"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path d="M5 5l10 10M15 5L5 15" stroke={color} strokeWidth={2} strokeLinecap="round" />;
        </svg>
    );
};
